export default __webpack_public_path__ + "static/media/Tea.29fc9873.png";